import { FaAngleRight, FaAngleLeft } from "react-icons/fa";

function FooterNavigation({
    leftClick,
    rightClick,
    currentIndex,
    length,
    assetType
}) {
    return (
        <div className="update-navigation">
        <FaAngleLeft
            className={`paginator ${currentIndex === 0 ? 'disabled' : ''}`}
            style={{ marginRight: '1rem' }}
            onClick={leftClick}
        />
        <span className="update-counter">
            {assetType} {currentIndex + 1} of {length}
        </span>
        <FaAngleRight
            className={`paginator ${currentIndex === length - 1 ? 'disabled' : ''}`}
            style={{ marginLeft: '1rem' }}
            onClick={rightClick}
        />
    </div>
    )
}

export default FooterNavigation;